<div class="container">
    <div>
        <div>
            <h1 class="mat-headline-1">Help Centre</h1>
        </div>

         
    </div>
    <div fxLayout="row" style="margin-top: 60px;">
        <div fxFlex="50">
            <div>
                <h2>Have a quick question?</h2>
                <p>All of the articles created in the nettTracker <a href="https://farscape-applications.zendesk.com/hc/en-gb" target="_blank">Knowledgebase</a> have been written in response to questions
                    asked by our users.  The answer you have been looking for may be just a few clicks away.
                </p>
            </div>
            <div>
                <h2>Would you like everything setup for you?</h2>
                <p>Click <a href="https://www.nett-tracker.com/free-onboarding" target="_blank">here</a> to find out more about our 'on-boarding' service.</p>
            </div>
        </div>
        <div fxFlex="50">
            <div>
                <h2>Subscriptions, payments and other queries?</h2>
                <p>
                    If you are unable to find the answer you are looking for within our tutorials and Knowledgebase, please raise a support ticket
                    and our team will respond as soon as possible.  Please allow 24 hours if contacting us from outside the United Kingdom.
                </p>
            </div>
        </div>
       
    </div>

    <mat-divider></mat-divider>
      
    <div fxLayout="row" >
        <div fxFlex="50">
            <h2>Have we already answered your question?</h2>    
            <p>
                Quite often, the answer you are looking for can be found within the support documentation available within the knowledge base and video tutorials.
            </p>
            <p>
                However, if you are experiencing a problem with nettTracker, please provide us with as much information as possible.
            </p>
            <p><b>For example:</b></p>
            <ul>
                <li>Asset/Prepayment Group</li>
                <li>Item name, reference, description</li>
                <li>Original values</li>
                <li>Date</li>
                <li>Chart of account category</li>
            </ul>
            <p>
                The more information that is provided to us, the easier it becomes to help resolve any queries or problems you may have.
            </p>
        </div>
        <div fxFlex="50">
          <div *ngIf="pendingSupport">
            <h2>Create a support ticket</h2>
                <div [formGroup]="form">
                    <mat-form-field class="mat-field-width">
                        <mat-label>I need help with...</mat-label>
                        <mat-select formControlName="subject">
                        <mat-option value="Setup">Setup service</mat-option>
                        <mat-option value="Billing">Subscription &amp; billing</mat-option>
                        <mat-option value="NettTracker">nettTracker problems</mat-option>
                        <mat-option value="Account">Login issues</mat-option>
                        </mat-select>
                    </mat-form-field>
            
                    <mat-form-field class="mat-field-width" *ngIf="showCompany">
                        <mat-label>Affected company</mat-label>
                        <mat-select formControlName="company">
                        <mat-option *ngFor="let c of companies" value="{{c.safeId}}">
                            {{c.companyName}}
                        </mat-option>
                        </mat-select>
                    </mat-form-field>
                    <p *ngIf="showCompany">
                        Please note that we may require access to your nettTracker company
                        to investigate your issue.  Submitting this ticket gives your consent
                        to this.
                    </p>
                    <mat-form-field class="mat-field-width">
                        <textarea matInput
                                placeholder="Describe the problem"
                                formControlName="body"
                                rows="10"></textarea>
                        <mat-error>Required</mat-error>
                    </mat-form-field>
        
                    <p>
                        <button mat-raised-button color="primary" (click)="submit()">
                        Create support ticket
                        </button>
                    </p>
                    <p *ngIf="ticketError" class="alert-danger">There was a problem submitting your ticket.  Please check your information and try again.</p>
                </div>
            </div>
            <div *ngIf="sendingRequest">
                <p>Please wait while we send your request</p>
                <mat-progress-spinner class="mat-spinner-center"
                                    color="primary"
                                    mode="indeterminate">
                </mat-progress-spinner>
            </div>
            <div *ngIf="requestReceived">
                <h2>Support request received</h2>
                <p>Thank you.  We have received your support request and we will respond to you as soon as possible.</p>
                <p>Your ticket number is {{ticketNumber}}.</p>
            </div>
        </div>
    </div>

    

   


</div>